export const ChartLegend = ({ color, label, valuePercent, value }) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <div className={`w-3 h-3 rounded-full ${color}`} />
        <span className="min-w-[100px] text-[14px]/[20px] text-base-1000">
          {label}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span className="w-11 text-[16px]/[24px] text-base-1000 font-medium text-right truncate">
          {valuePercent}
        </span>
        <span className="w-11 text-[16px]/[24px] text-base-800 text-right truncate">
          {value}
        </span>
      </div>
    </div>
  );
};
